<h2 mat-dialog-title>
    <div>
      <span *ngIf="popups">Modifica Popup: {{ popups.title }}</span>
      <span *ngIf="!popups">Nuovo Popup</span>
    </div>

    <div class="header-actions" *ngIf="popups">
        <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
          <button mat-menu-item (click)="deletePopup()">
            <mat-icon>delete</mat-icon>
            Elimina popup
          </button>
        </mat-menu>
    </div>

  </h2>
  
  <mat-dialog-content>
    <form [formGroup]="popupsForm" novalidate>
      <mat-error *ngIf="!popups && popupsForm.get('image').hasError('required')" style="text-align: center;">Immagine obbligatoria</mat-error>
      <div class="avatar-upload">
        <div class="avatar-edit">
          <input type="file" (change)="onFileSelected($event)" id="imageUpload" accept=".png, .jpg, .jpeg" />
          <label for="imageUpload"></label>
        </div>
        <div class="avatar-preview">
          <div id="imagePreview" style="background-image: url(../../../../../../../assets/images/no-image.jpg);">
          </div>
        </div>
      </div>
  
      <div class="u-flex-full">
        <mat-form-field class="u-full-width">
          <mat-label>Titolo</mat-label>
          <input matInput formControlName="title" placeholder="Titolo" required>
          <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>
  
        <mat-form-field class="u-full-width">
          <mat-label>Contenuto</mat-label>
          <input matInput formControlName="content" placeholder="Contenuto" required>
          <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>
      </div>
  
      <div class="u-flex-full">
        <mat-form-field class="u-full-width">
            <mat-label>Data Inizio</mat-label>
            <input matInput [matDatepicker]="pickerFrom" formControlName="start_date" placeholder="Seleziona Data"/>
            <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
            <mat-datepicker #pickerFrom></mat-datepicker>
            <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>

        <mat-form-field class="u-full-width">
            <mat-label>Data Fine</mat-label>
            <input matInput [matDatepicker]="pickerTo" formControlName="end_date" placeholder="Seleziona Data">
            <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
            <mat-datepicker #pickerTo></mat-datepicker>
            <mat-error>Campo obbligatorio</mat-error>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  
  <mat-dialog-actions>
    <div class="left-actions">
      <button mat-raised-button  type="button" (click)="resetForm()"
        [disabled]="popupsForm.pristine">
        Reset
      </button>
      <button mat-raised-button color="primary" type="button" (click)="save()"
        [disabled]="popupsForm.pristine || !popupsForm.valid">
        Salva
      </button>
    </div>
    <div>
      <button mat-raised-button type="button" (click)="close()">
        Chiudi
      </button>
    </div>
  </mat-dialog-actions>
  